/**
 * 分场景类别统计（mock v3 第六段）：按 ``scene_group`` 的 Δ 分档矩阵。
 *
 * 分组维度是 ``scene_group`` 而不是 ``label``：后者是逗号拼接的多值串，按整串分组会
 * 把「夜间雨天,路口拥堵」和「路口拥堵」算成两个不同的桶；``scene_group`` 由后端
 * ``derive_scene_group()`` 收敛为 22 个单值之一，天然是分区。``label`` 原文仍在
 * case 明细行里展示。
 */
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';

import type { PerceptionSceneGroupDeltaRow } from '@/apis/simulation';
import { sceneGroupDisplay } from '@/constants/sceneGroup';

import { BUCKET_DEFS } from './DeltaBucketCards';

const columns: ColumnsType<PerceptionSceneGroupDeltaRow> = [
  {
    title: '场景分组',
    dataIndex: 'sceneGroup',
    key: 'sceneGroup',
    width: 150,
    render: (v: string) => sceneGroupDisplay(v),
  },
  ...BUCKET_DEFS.map((def) => ({
    title: def.label,
    dataIndex: def.key,
    key: def.key,
    width: 100,
    align: 'right' as const,
    sorter: (a: PerceptionSceneGroupDeltaRow, b: PerceptionSceneGroupDeltaRow) =>
      a[def.key] - b[def.key],
  })),
  {
    title: '合计',
    dataIndex: 'total',
    key: 'total',
    width: 90,
    align: 'right',
    sorter: (a, b) => a.total - b.total,
  },
];

export default function SceneGroupTable({
  rows,
}: {
  rows: PerceptionSceneGroupDeltaRow[];
}) {
  return (
    <Table<PerceptionSceneGroupDeltaRow>
      rowKey="sceneGroup"
      size="small"
      dataSource={rows}
      columns={columns}
      pagination={false}
      tableLayout="fixed"
      scroll={{ x: 640, y: 320 }}
    />
  );
}
